var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCoupon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.31,
    height: 19.608,
    viewBox: "0 0 18.31 19.608",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1143",
    "data-name": "Group 1143",
    transform: "translate(-911 -546)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gift",
    transform: "translate(911 546)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M383.076,84.109h0a1.5,1.5,0,0,1-2.127,0l-1.063-1.063,1.063-1.063a1.5,1.5,0,0,1,2.127,0h0A1.5,1.5,0,0,1,383.076,84.109Z",
    transform: "translate(-368.594 -79.118)",
    fill: "#fe8f8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M381.668,105.279h0a.841.841,0,0,1-1.189,0l-.595-.594.595-.594a.841.841,0,0,1,1.189,0h0A.841.841,0,0,1,381.668,105.279Z",
    transform: "translate(-368.593 -100.757)",
    fill: "#ff5d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M329.766,10.507h0a1.5,1.5,0,0,0,0,2.125l1.063,1.063,1.063-1.063a1.5,1.5,0,0,0,0-2.125h0A1.5,1.5,0,0,0,329.766,10.507Z",
    transform: "translate(-319.537 -9.768)",
    fill: "#fe8f8d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M353.788,68.8h0a.783.783,0,0,0,0,1.107l.553.553.553-.553a.783.783,0,0,0,0-1.107h0A.783.783,0,0,0,353.788,68.8Z",
    transform: "translate(-343.05 -66.533)",
    fill: "#ff5d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M194.864,19.37,186.793,11.3l1.011-1.011a.984.984,0,0,1,1.391,0l6.68,6.68a.984.984,0,0,1,0,1.391Z",
    transform: "translate(-181.241 -9.703)",
    fill: "#4dbaf6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M10.008,216H20.234v7.446a1.055,1.055,0,0,1-1.055,1.055H11.063a1.055,1.055,0,0,1-1.055-1.055Z",
    transform: "translate(-9.711 -209.581)",
    fill: "#ade5ff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_78",
    "data-name": "Rectangle 78",
    width: 1.115,
    height: 1.115,
    transform: "translate(4.662 3.085) rotate(135)",
    fill: "#ff5d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M148.148,341v4.786h-2.14v-3.523A1.263,1.263,0,0,1,147.271,341h.877Z",
    transform: "translate(-141.668 -330.864)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M187.235,341h0a.915.915,0,0,1,.915.915v2.266l1.133-1.12,1.007,1.12v-2A1.184,1.184,0,0,0,189.106,341h-1.871",
    transform: "translate(-181.67 -330.864)",
    fill: "#d8d8e4"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_79",
    "data-name": "Rectangle 79",
    width: 2.14,
    height: 2.413,
    transform: "translate(10.344 6.388) rotate(-135)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M344.305,342.5a.3.3,0,1,0,.21.087A.3.3,0,0,0,344.305,342.5Z",
    transform: "translate(-333.782 -332.319)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M136.305,306.787a.3.3,0,0,0-.3.3v.006a.3.3,0,0,0,.595,0v-.006A.3.3,0,0,0,136.305,306.787Z",
    transform: "translate(-131.965 -297.668)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M14.852,7.056,13.522,5.725A1.794,1.794,0,0,0,14.7,5.2h0a1.8,1.8,0,0,0-1.636-3.037A1.816,1.816,0,0,0,13.1,1.8a1.8,1.8,0,0,0-3.6-.1L8.172.375a1.281,1.281,0,0,0-1.811,0L5.35,1.386a.3.3,0,0,0,0,.42L8.629,5.085h0l.757.757.282.282H6.473V4.607a.3.3,0,1,0-.595,0V6.124H2.208V5.06A1.184,1.184,0,0,0,1.025,3.877,1.007,1.007,0,0,0,.019,4.883a.865.865,0,0,0,.864.864.3.3,0,1,0,0-.595.27.27,0,0,1-.27-.27.412.412,0,0,1,.411-.411.589.589,0,0,1,.589.589V6.124H.305a.3.3,0,0,0-.3.3v7.446a1.354,1.354,0,0,0,1.353,1.353H9.476a1.354,1.354,0,0,0,1.353-1.353V11.652a.3.3,0,1,0-.595,0v2.215a.759.759,0,0,1-.758.758H6.785V13.441l.823-.814.8.888a.3.3,0,0,0,.518-.2v-2A1.483,1.483,0,0,0,7.444,9.839s-1.892,0-1.9,0A1.562,1.562,0,0,0,4.051,11.4v3.225H1.36A.759.759,0,0,1,.6,13.867V6.718H4.051V8.373a.3.3,0,1,0,.595,0V6.718h5.588V9.334a.3.3,0,0,0,.595,0V7.284l2.593,2.593a.3.3,0,0,0,.42,0l1.011-1.011A1.282,1.282,0,0,0,14.852,7.056ZM7.444,10.434a.888.888,0,0,1,.887.887v1.221L7.843,12a.3.3,0,0,0-.43-.013l-.627.62V11.051a1.2,1.2,0,0,0-.169-.617Zm-2.8.966a.967.967,0,0,1,.941-.965.618.618,0,0,1,.6.617v3.574H4.645Zm5.707-5.432L9.26,4.875l1.284-1.284.547.547h0l.546.546Zm.462-3.147a.482.482,0,0,1,.142-.343h0a.485.485,0,0,1,.686.686l-.341.341-.38-.38A.482.482,0,0,1,10.815,2.821Zm1.332,1.529-.424-.424.341-.341h0l.041-.041a.543.543,0,1,1,.042.806ZM14.28,3.074A1.206,1.206,0,0,1,12.872,5a1.138,1.138,0,0,0,0-2.143A1.209,1.209,0,0,1,14.28,3.074ZM10.448.95h0a1.206,1.206,0,0,1,1.867,1.5,1.08,1.08,0,0,0-2.03,0A1.208,1.208,0,0,1,10.448.95ZM6.781.8a.686.686,0,0,1,.971,0L9.959,3c.022.025.045.049.068.072l.1.1L8.839,4.455,5.981,1.6Zm7.651,7.651-.8.8-2.8-2.8V6.421a.3.3,0,0,0-.01-.077L12.057,5.1l.1.1c.024.024.048.046.072.068l2.206,2.206A.687.687,0,0,1,14.432,8.446Z",
    transform: "translate(-0.008)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M75.121,28.285h.2a.3.3,0,1,0,0-.595h-.2a.3.3,0,1,0,0,.595Z",
    transform: "translate(-72.6 -26.867)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M26.6,28.285h.2a.3.3,0,0,0,0-.595h-.2a.3.3,0,0,0,0,.595Z",
    transform: "translate(-25.521 -26.867)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M54.291,49.318a.3.3,0,0,0,.3-.3v-.2a.3.3,0,1,0-.595,0v.2A.3.3,0,0,0,54.291,49.318Z",
    transform: "translate(-52.389 -47.078)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M54.291.8a.3.3,0,0,0,.3-.3V.3a.3.3,0,0,0-.595,0V.5A.3.3,0,0,0,54.291.8Z",
    transform: "translate(-52.389)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M93.879,68.556l.788.788a.3.3,0,0,0,.42,0l.788-.788a.3.3,0,0,0,0-.42l-.788-.788a.3.3,0,0,0-.42,0l-.788.788A.3.3,0,0,0,93.879,68.556Zm1-.578.368.368-.368.368-.368-.368Z",
    transform: "translate(-91.004 -65.261)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M143.764,157.7a.3.3,0,1,0,.21-.087A.3.3,0,0,0,143.764,157.7Z",
    transform: "translate(-139.406 -152.925)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "tap",
    transform: "translate(921.999 555.385)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M6.794,53.266H6.779a.539.539,0,0,0-.524.553v.431a.155.155,0,1,1-.311,0v-.8a.513.513,0,1,0-1.022,0V54.3a.155.155,0,0,1-.311,0V53.222a.538.538,0,0,0-.519-.556H4.077a.52.52,0,0,0-.509.533v1.21a.155.155,0,1,1-.311,0V53.234s0-.008,0-.012,0-.019,0-.029V50.446a.544.544,0,0,0-.519-.564.545.545,0,0,0-.519.563l0,4.556a.156.156,0,0,1-.276.1L1.4,54.438a.828.828,0,0,0-.585-.309.81.81,0,0,0-.609.218L.2,54.353l-.106.089,1.886,3.624A1.673,1.673,0,0,0,3.445,59h2.18a1.758,1.758,0,0,0,1.684-1.816c0-.529,0-.927,0-1.247,0-.855,0-1.17,0-2.112A.537.537,0,0,0,6.794,53.266Zm0,0",
    transform: "translate(0 -48.775)",
    fill: "#8aa896"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M48.749,1.726a.155.155,0,0,0,.155-.155,1.254,1.254,0,1,1,2.507,0,.155.155,0,0,0,.311,0,1.565,1.565,0,1,0-3.129,0A.156.156,0,0,0,48.749,1.726Zm0,0",
    transform: "translate(-47.426)",
    fill: "#8aa896"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCoupon);
export default __webpack_public_path__ + "static/media/icon_coupon.681986fc1d61713cc456046ae4564ef4.svg";
export { ForwardRef as ReactComponent };